module.exports = __webpack_public_path__ + "img/39.e67b5da3.jpg";